"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-shopping_cart text-3xl relative" }, null, -1);
const _hoisted_3 = {
    key: 0,
    class: "bg-black text-white p-1 absolute top-0 rounded right-[6px]"
};
const _hoisted_4 = {
    key: 0,
    class: "hidden peer-hover:block hover:block bg-white drop-shadow-lg absolute w-[250px] rounded right-0"
};
const _hoisted_5 = ["onClick"];
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("../Modal.vue"));
const CartModal_vue_1 = __importDefault(require("./CartModal.vue"));
const i18n_1 = require("../../common/i18n");
const cartsStore_1 = require("../../stores/carts/cartsStore");
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CartsDesktop',
    props: {
        disabled: {
            type: Boolean,
            default: true
        },
        id: {
            type: String,
            default: () => { var _a; return `carts-desktop-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; }
        }
    },
    setup(__props) {
        const props = __props;
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const router = (0, vue_router_1.useRouter)();
        const activeCartModalVisible = (0, vue_3.computed)(() => cartsStore.activeCartModalVisible);
        const activeCart = (0, vue_3.computed)(() => cartsStore.activeCart);
        const activeCartSize = (0, vue_3.computed)(() => { var _a; return (_a = activeCart.value) === null || _a === void 0 ? void 0 : _a.getSize(); });
        const carts = (0, vue_3.computed)(() => cartsStore.carts);
        const showActiveCartModal = () => {
            cartsStore.showActiveCartModal(router);
        };
        const selectCart = (cartId) => {
            cartsStore.changeActiveCartId(cartId);
            cartsStore.showActiveCartModal(router);
        };
        const closeActiveCartModal = () => {
            cartsStore.closeActiveCartModal();
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                ((0, vue_2.unref)(activeCart) !== undefined)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: 0,
                        id: __props.id,
                        class: "text-black relative"
                    }, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "peer px-2 xl:px-5 py-2 text-white",
                            onClick: _cache[0] || (_cache[0] = ($event) => (showActiveCartModal()))
                        }, [
                            _hoisted_2,
                            ((0, vue_2.unref)(activeCartSize) !== undefined && (0, vue_2.unref)(activeCartSize) > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(activeCartSize)), 1))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        ((0, vue_2.unref)(carts).length > 1)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(carts), (cart, index) => {
                                    var _a;
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: cart.id,
                                        onClick: ($event) => (selectCart(cart.id)),
                                        class: (0, vue_2.normalizeClass)([((_a = (0, vue_2.unref)(activeCart)) === null || _a === void 0 ? void 0 : _a.id) === cart.id ? 'bg-red text-white' : '', "font-normal p-2 border-b-1 border-gray normal-case text-center hover:bg-gray hover:text-black last:border-b-0 cursor-pointer"])
                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_item", "{index}. cart - number of products: {cartSize}", "carts", {
                                        index: index + 1,
                                        cartSize: cart.getSize(),
                                    })), 11, _hoisted_5));
                                }), 128))
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ], 8, _hoisted_1))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(activeCart) && __props.disabled)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                        key: 1,
                        isOpen: (0, vue_2.unref)(activeCartModalVisible),
                        title: (0, vue_2.unref)(i18n_1.trans)('cart_modal_title', 'Cart', 'carts'),
                        widthClasses: "w-full max-w-full max-w-screen-xl",
                        backgroundColorClass: "bg-[#f2f2f2]",
                        onClose: _cache[1] || (_cache[1] = ($event) => (closeActiveCartModal()))
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(CartModal_vue_1.default, { id: "carts-desktop-cart-modal" })
                        ]),
                        _: 1
                    }, 8, ["isOpen", "title"]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
